module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAOCAYAAAAfSC3RAAABCklEQVQ4T53SsU7DMBAG4P8HCmJIL4u9M/ACLDwCQsDAgMoAAyOvRWEIFHXjIVgYQYKNLVliRpA4ZFO3cfGAktHx5/N/PqLnx54Oc+jEPJN8Kdp6ROCze6ACgw8xY4Bb4upd/28BSzsGcKaKqbiAv/yGV2DDluYO4BFUK3HNaQIVWHVibkiOIn4DVmxp7gEeLB+YZFzGpK7nUFIxZlJgzYm9JXEc1lSroWvO49Xjvj9dnWWaADz8dWnmLJyhkAnQK1UWvnIOzyu+A5uF2CmJPY+GbXOB0DBb5XD3HR9A7kdE4DtcFRgssE5K15yk7yjmkeBT4erLiDoN8wNwDXJH2no729X/jmDvWf0BHU19D0yo538AAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/cloudService/icon_error.png
// module id = wUgy
// module chunks = 174